var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "193.42 78.9 172.78 58.26 193.42 37.62 182.48 26.68 161.84 47.32 141.2 26.68 130.26 37.62 150.9 58.26 130.26 78.9 141.2 89.84 161.84 69.2 182.48 89.84 193.42 78.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "93.86 145.34 64.67 145.34 64.67 116.15 49.2 116.15 49.2 145.34 20.01 145.34 20.01 160.81 49.2 160.81 49.2 190 64.67 190 64.67 160.81 93.86 160.81 93.86 145.34"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.75,
    y: 33.93,
    width: 64.37,
    height: 17.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.75,
    y: 65.37,
    width: 64.37,
    height: 17.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.66,
    y: 144.8,
    width: 64.37,
    height: 17.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 161.84,
    cy: 122.99,
    r: 10.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 161.84,
    cy: 183.16,
    r: 10.58
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMath);
export default __webpack_public_path__ + "static/media/MATH.5ec08e1f9f8814ef1700f3c74f1dc5af.svg";
export { ForwardRef as ReactComponent };